import { FC } from 'react';
import { TierIconProps } from './TierIcon';

const PhenomTierIcon: FC<TierIconProps> = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="url(#paint0_linear_1755_9747)"
        stroke="url(#paint1_linear_1755_9747)"
        strokeWidth="2"
      />
      <g style={{ mixBlendMode: 'overlay' }}>
        <path d="M22.193 46.4988L20.2316 49.3136H43.7974L41.836 46.4988H22.193Z" fill="black" />
        <path
          d="M25.6271 35.827L21.1686 42.2284H19.5C18.3817 42.2284 17.4098 41.614 16.9004 40.5879C16.3911 39.5619 16.473 38.3876 17.1229 37.4463L28.3496 21.2295V45.0432H31.0721V12.4613L14.9098 35.8089C13.6715 37.5946 13.5075 39.919 14.4795 41.8743C15.4514 43.8295 17.3747 45.0432 19.5 45.0432H25.6271V35.827Z"
          fill="black"
        />
        <path
          d="M38.3702 35.827L42.8286 42.2284H44.4973C45.6156 42.2284 46.5875 41.614 47.0968 40.5879C47.6062 39.5619 47.5242 38.3876 46.8744 37.4463L35.6477 21.2295V45.0432H32.9252V12.4613L49.0904 35.8089C50.3287 37.5946 50.4926 39.919 49.5207 41.8743C48.5488 43.8295 46.6255 45.0432 44.5002 45.0432H38.3731V35.827H38.3702Z"
          fill="black"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1755_9747"
          x1="47.4667"
          y1="59.2"
          x2="5.33333"
          y2="9.06667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C1F57" />
          <stop offset="0.340775" stopColor="#654186" />
          <stop offset="0.595" stopColor="#D3C7DC" />
          <stop offset="0.793593" stopColor="#B064F0" />
          <stop offset="1" stopColor="#9A47DF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1755_9747"
          x1="47.4667"
          y1="59.2"
          x2="5.33333"
          y2="9.06667"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="#3C1F57" />
          <stop offset="0.659225" stopColor="#654186" />
          <stop offset="0.405" stopColor="#D3C7DC" />
          <stop offset="0.206407" stopColor="#B064F0" />
          <stop stopColor="#9A47DF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default PhenomTierIcon;
